import { render, staticRenderFns } from "./ModalHistoryEdit.vue?vue&type=template&id=664e88e8&scoped=true"
import script from "./ModalHistoryEdit.vue?vue&type=script&lang=js"
export * from "./ModalHistoryEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoryEdit.vue?vue&type=style&index=0&id=664e88e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664e88e8",
  null
  
)

export default component.exports